/**
 * Empty-state graphic for the Vendors page — Richa's "Profile" promo
 * illustration (Figma "Graphics - Icons" file, node 999:4560), per
 * https://paywithextend.slack.com/archives/C0BFCFQ3015/p1785273521170839.
 * Static decorative graphic only, never interactive (confirmed in-thread —
 * the earlier placeholder plus-icon was mistaken for a clickable "add" CTA).
 * Multi-color illustration exported as-is from Figma; raw hex fills are
 * expected here per ext-ui's own exception for generated/exported SVG
 * source, not a token-usage gap like a semantic icon would be.
 */
import React from 'react'

export function VendorsEmptyIllustration() {
  return (
    <svg
      width="79"
      height="80"
      viewBox="0 0 79 80"
      fill="none"
      aria-hidden="true"
    >
      <g filter="url(#filter0_d_999_4560)">
        <mask
          id="mask0_999_4560"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="5"
          y="3"
          width="69"
          height="70"
        >
          <path
            d="M39.5 73C58.5538 73 74 57.33 74 38C74 18.67 58.5538 3 39.5 3C20.4462 3 5 18.67 5 38C5 57.33 20.4462 73 39.5 73Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_999_4560)">
          <g filter="url(#filter1_d_999_4560)">
            <path
              d="M39.5 73C58.5538 73 74 57.33 74 38C74 18.67 58.5538 3 39.5 3C20.4462 3 5 18.67 5 38C5 57.33 20.4462 73 39.5 73Z"
              fill="black"
            />
          </g>
          <path
            d="M39.5 73C58.5538 73 74 57.33 74 38C74 18.67 58.5538 3 39.5 3C20.4462 3 5 18.67 5 38C5 57.33 20.4462 73 39.5 73Z"
            fill="#FCFCFF"
          />
          <g filter="url(#filter2_d_999_4560)">
            <path
              d="M-4.82056 72.1493C-8.57462 55.2222 -2.94353 46.7587 12.0727 46.7587C27.0889 46.7587 32.72 55.2222 28.966 72.1493"
              fill="black"
            />
          </g>
          <path
            d="M-4.82056 72.1493C-8.57462 55.2222 -2.94353 46.7587 12.0727 46.7587C27.0889 46.7587 32.72 55.2222 28.966 72.1493"
            fill="#3475F2"
          />
          <g filter="url(#filter3_d_999_4560)">
            <path
              d="M12.0729 49.4299C18.044 49.4299 22.8846 44.5477 22.8846 38.5254C22.8846 32.503 18.044 27.6208 12.0729 27.6208C6.10179 27.6208 1.26123 32.503 1.26123 38.5254C1.26123 44.5477 6.10179 49.4299 12.0729 49.4299Z"
              fill="black"
            />
          </g>
          <path
            d="M12.0729 49.4299C18.044 49.4299 22.8846 44.5477 22.8846 38.5254C22.8846 32.503 18.044 27.6208 12.0729 27.6208C6.10179 27.6208 1.26123 32.503 1.26123 38.5254C1.26123 44.5477 6.10179 49.4299 12.0729 49.4299Z"
            fill="#A6C8FE"
          />
          <g filter="url(#filter4_d_999_4560)">
            <path
              d="M56.4453 62.2495C53.7549 50.1587 57.7905 44.1133 68.5521 44.1133C79.3138 44.1133 83.3494 50.1587 80.659 62.2495"
              fill="black"
            />
          </g>
          <path
            d="M56.4453 62.2495C53.7549 50.1587 57.7905 44.1133 68.5521 44.1133C79.3138 44.1133 83.3494 50.1587 80.659 62.2495"
            fill="#BDC1C8"
          />
          <g filter="url(#filter5_d_999_4560)">
            <path
              d="M68.5521 46.307C72.8314 46.307 76.3005 42.8198 76.3005 38.5181C76.3005 34.2163 72.8314 30.7291 68.5521 30.7291C64.2728 30.7291 60.8037 34.2163 60.8037 38.5181C60.8037 42.8198 64.2728 46.307 68.5521 46.307Z"
              fill="black"
            />
          </g>
          <path
            d="M68.5521 46.307C72.8314 46.307 76.3005 42.8198 76.3005 38.5181C76.3005 34.2163 72.8314 30.7291 68.5521 30.7291C64.2728 30.7291 60.8037 34.2163 60.8037 38.5181C60.8037 42.8198 64.2728 46.307 68.5521 46.307Z"
            fill="#D8DADE"
          />
          <g filter="url(#filter6_d_999_4560)">
            <path
              d="M16.0926 81.3035C10.8995 57.8473 18.6892 46.1193 39.4616 46.1193C60.2341 46.1193 68.0237 57.8473 62.8306 81.3035"
              fill="black"
            />
          </g>
          <path
            d="M16.0926 81.3035C10.8995 57.8473 18.6892 46.1193 39.4616 46.1193C60.2341 46.1193 68.0237 57.8473 62.8306 81.3035"
            fill="#82DCC9"
          />
          <g filter="url(#filter7_d_999_4560)">
            <path
              d="M39.6007 51.6456C47.8608 51.6456 54.5569 44.8804 54.5569 36.5351C54.5569 28.1898 47.8608 21.4246 39.6007 21.4246C31.3406 21.4246 24.6445 28.1898 24.6445 36.5351C24.6445 44.8804 31.3406 51.6456 39.6007 51.6456Z"
              fill="black"
            />
          </g>
          <path
            d="M39.6007 51.6456C47.8608 51.6456 54.5569 44.8804 54.5569 36.5351C54.5569 28.1898 47.8608 21.4246 39.6007 21.4246C31.3406 21.4246 24.6445 28.1898 24.6445 36.5351C24.6445 44.8804 31.3406 51.6456 39.6007 51.6456Z"
            fill="#00AC8E"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_999_4560"
          x="0"
          y="0"
          width="79"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_999_4560"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_999_4560"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_999_4560"
          x="0"
          y="0"
          width="79"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_999_4560"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_999_4560"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_999_4560"
          x="-9.94678"
          y="43.7587"
          width="44.0391"
          height="33.3906"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_999_4560"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_999_4560"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_999_4560"
          x="-2.73877"
          y="24.6208"
          width="29.6235"
          height="29.809"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_999_4560"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_999_4560"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_999_4560"
          x="52.6382"
          y="42.1133"
          width="31.8281"
          height="24.1362"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_999_4560"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_999_4560"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_999_4560"
          x="57.8037"
          y="28.7291"
          width="21.4966"
          height="21.5779"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_999_4560"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_999_4560"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_999_4560"
          x="9.53467"
          y="43.1193"
          width="59.854"
          height="45.1842"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_999_4560"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_999_4560"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_999_4560"
          x="19.6445"
          y="18.4246"
          width="39.9121"
          height="40.2211"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_999_4560"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_999_4560"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
